module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "culture-and-environment.b8175804.webp" + "?" + Date.now();